<template>
  <vs-popup
    :title="title"
    :active.sync="valueLocal"
    v-modal-no-scroll-body
    :style="onModal && valueLocal ? 'z-index: 53001 !important; display: block !important;' : ''"
    :class="onModal ? 'on-modal' : ''"
  >
    <transition name="zoom-fade">
      <dedicated-number-payment-checkout
        v-show="valueLocal"
        :shown="valueLocal"
        :caller-id="callerId"
        :on-payment-intent-callback="onPaymentIntentCallback"
        @payment="onPayment"/>
    </transition>
  </vs-popup>
</template>

<script>
// Components
import DedicatedNumberPaymentCheckout from '@/views/modules/sender-ids/caller-id/_components/DedicatedNumberPaymentCheckout.vue';

/**
 * Dedicated number payment checkout modal
 *
 * @module views/modules/sender-ids/caller-id/_components/DedicatedNumberPaymentCheckoutModal
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 */
export default {
  name: 'DedicatedNumberPaymentCheckoutModal',
  i18n: {
    messages: {
      en: {
        Pay: 'Dedicated number payment',
        Resubscribe: 'Resubscribe to dedicated number',
      },
    },
  },
  components: {
    DedicatedNumberPaymentCheckout,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    callerId: {
      type: Object,
      required: true,
    },
    onPaymentIntentCallback: {
      type: Function,
      required: false,
      default: null,
    },
    onModal: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      valueLocal: this.value,
    };
  },
  computed: {
    callerIdStatus() {
      return this.callerId.status
        ? this.callerId.status
        : '';
    },
    isExpiredOrCanceled() {
      return this.callerIdStatus === this.$enums.Sender.Caller.DedicatedNumberStatus.EXPIRED_PAYMENT
        || this.callerIdStatus === this.$enums.Sender.Caller.DedicatedNumberStatus.CANCELED;
    },
    title() {
      // eslint-disable-next-line max-len
      if (this.isExpiredOrCanceled) {
        return this.$t('Resubscribe');
      }

      return this.$t('Pay');
    },
  },
  watch: {
    value(val) {
      this.valueLocal = val;
    },
    valueLocal(val) {
      this.$emit('input', val);
    },
  },
  methods: {
    onPayment() {
      this.$emit('payment');
      this.valueLocal = false;
    },
  },
};
</script>

<style scoped>

</style>
